export const blockIconsEditorChecklist = (
	<span className='material-symbols-outlined'>checklist</span>
);
